import { sntTranslate } from "src/app/support/translate";
import { marker } from "@jsverse/transloco-keys-manager/marker";
import { QuoteLight } from "src/app/backend/models/quote/quote";
import { dateUtil } from "src/app/support/date-util";

export function getQuoteFileName(
  quote: QuoteLight,
  omitDate: boolean = false,
  omitFileExtension: boolean = false
): string {
  let text = `${sntTranslate(marker("Preventivo n."))} ${quote.number}`;

  const date = quote.createdAt || undefined;

  if (date && !omitDate) {
    text = `${text} ${sntTranslate(marker("del"))} ${dateUtil(date).format(
      "DD/MM/YYYY"
    )}`;
  }

  return omitFileExtension ? text : `${text}.pdf`;
}
